var _path, _g, _g2, _g3, _g4, _g5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStats1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Live_1_",
    xmlns: "http://www.w3.org/2000/svg",
    width: 51.109,
    height: 51.109,
    viewBox: "0 0 51.109 51.109",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_215397",
    "data-name": "Path 215397",
    d: "M46.617,242H4.492A4.5,4.5,0,0,0,0,246.492V264.46a4.5,4.5,0,0,0,4.492,4.492H46.617a4.5,4.5,0,0,0,4.492-4.492V246.492A4.5,4.5,0,0,0,46.617,242ZM13.576,262.963H7.586a1.5,1.5,0,0,1-1.5-1.5V249.487a1.5,1.5,0,1,1,2.995,0v10.481h4.492a1.5,1.5,0,1,1,0,2.995Zm7.487-1.5a1.5,1.5,0,0,1-2.995,0V249.487a1.5,1.5,0,1,1,2.995,0ZM33,249.849,30,261.828a1.5,1.5,0,0,1-2.9,0L24.1,249.849a1.5,1.5,0,0,1,2.9-.725l1.543,6.168,1.543-6.168a1.5,1.5,0,0,1,2.9.725Zm10.527,4.129a1.5,1.5,0,0,1,0,2.995H39.03v2.995h4.492a1.5,1.5,0,1,1,0,2.995H37.533a1.5,1.5,0,0,1-1.5-1.5V249.487a1.5,1.5,0,0,1,1.5-1.5h5.989a1.5,1.5,0,1,1,0,2.995H39.03v2.995Z",
    transform: "translate(0 -217.843)",
    fill: "#00057d"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_98079",
    "data-name": "Group 98079",
    transform: "translate(9.1 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_215398",
    "data-name": "Path 215398",
    d: "M94.437,20.364A16.543,16.543,0,0,1,94.437.6a1.5,1.5,0,1,1,2.4,1.8,13.529,13.529,0,0,0,0,16.169,1.5,1.5,0,1,1-2.4,1.8Z",
    transform: "translate(-91.16 0)",
    fill: "#00057d"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_98080",
    "data-name": "Group 98080",
    transform: "translate(36.037 0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_215399",
    "data-name": "Path 215399",
    d: "M361.615,20.668a1.5,1.5,0,0,1-.3-2.1,13.529,13.529,0,0,0,0-16.169,1.5,1.5,0,0,1,2.4-1.8,16.543,16.543,0,0,1,0,19.767A1.5,1.5,0,0,1,361.615,20.668Z",
    transform: "translate(-361.017 -0.006)",
    fill: "#00057d"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_98081",
    "data-name": "Group 98081",
    transform: "translate(15.066 2.996)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_215400",
    "data-name": "Path 215400",
    d: "M153.6,44.487a10.462,10.462,0,0,1,0-13.976,1.5,1.5,0,0,1,2.231,2,7.474,7.474,0,0,0,0,9.981,1.5,1.5,0,1,1-2.231,2Z",
    transform: "translate(-150.927 -30.014)",
    fill: "#00057d"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_98082",
    "data-name": "Group 98082",
    transform: "translate(30.754 2.995)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_215401",
    "data-name": "Path 215401",
    d: "M308.591,44.594a1.5,1.5,0,0,1-.117-2.114,7.474,7.474,0,0,0,0-9.981,1.5,1.5,0,1,1,2.231-2,10.463,10.463,0,0,1,0,13.976,1.5,1.5,0,0,1-2.114.117Z",
    transform: "translate(-308.093 -30.003)",
    fill: "#00057d"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_98083",
    "data-name": "Group 98083",
    transform: "translate(21.062 5.989)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_215402",
    "data-name": "Path 215402",
    d: "M215.492,68.984a4.492,4.492,0,1,1,4.492-4.492A4.5,4.5,0,0,1,215.492,68.984Z",
    transform: "translate(-211 -60)",
    fill: "#00057d"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStats1);
export default __webpack_public_path__ + "static/media/stats1.04894efab7ee0924c0ccc6204ad884bc.svg";
export { ForwardRef as ReactComponent };